<template lang="pug">

  button(
    ref="sosButton"
    :type="type === 'submit' ? 'submit' : 'button'"
    :class="{ 'sosButton': true, 'sosButton--showActions': showActions && !loading && !disabled, 'sosButton--full': full, 'sosButton--rounded': rounded, 'sosButton--uppercase': uppercase, 'sosButton--regular': size === 'regular', 'sosButton--medium': size === 'medium', 'sosButton--big': size === 'big', 'pulse': pulse === true, 'sosButton--transparent': color === 'transparent', 'sosButton--default': color !== 'transparent' && color !== 'success' && color !== 'blue' && color !== 'purple' && color !== 'lightblue', 'sosButton--lightgreen': color === 'lightgreen', 'sosButton--success': color === 'success', 'sosButton--blue': color === 'blue', 'sosButton--purple': color === 'purple', 'sosButton--lightblue': color === 'lightblue', 'sosButton--danger': color === 'danger', 'sosButton--lightgrey': color === 'lightgrey', 'sosButton--white': color === 'white', 'sosButton--grupoAcaoTodosPlantoesCompartilhar': color === 'grupoAcaoTodosPlantoesCompartilhar', 'sosButton--grupoAcaoTodosPlantoesVer': color === 'grupoAcaoTodosPlantoesVer', 'sosButton--grupoAcaoGerarFolhaDePonto': color === 'grupoAcaoGerarFolhaDePonto', 'sosButton--grupoAcaoConvidarUsuario': color === 'grupoAcaoConvidarUsuario', 'sosButton--grupoEscalaAcaoEditar': color === 'grupoEscalaAcaoEditar', 'sosButton--grupoEscalaAcaoVer': color === 'grupoEscalaAcaoVer', 'sosButton--grupoEscalaAcaoApagar': color === 'grupoEscalaAcaoApagar', 'sosButton--grupoEscalaAcaoCompartilhar': color === 'grupoEscalaAcaoCompartilhar', 'sosButton--tabFocused': isTabFocus }"
    @click="buttonClick"
    :disabled="disabled"
    @focus="onFocus"
    @keydown="onKeydown"
    @blur="onBlur"
    @mousedown="onMouseDown")

    i.mdi(
      v-if="iconPosition === 'left' && loading === false && !!buttonIcon === true && buttonIcon.length > 0"
      :class="{ [buttonIcon]: true, 'mr-1': size !== 'regular' && !!buttonLabel === true && buttonLabel.length > 0, 'mr-2': size === 'regular' && !!buttonLabel === true && buttonLabel.length > 0 }"
      :style="{ 'font-size': (buttonIconSize + 'px'), 'line-height': (buttonIconSize + 'px'), 'vertical-align': 'middle' }"
      aria-hidden="true")

    .buttonLoader(v-if="loading === true" :class="{ 'mr-2': !!buttonLabel === true && buttonLabel.length > 0 }")
      span

    template(v-if="!!buttonIcon === true && buttonIcon.length > 0")
      span(
        v-if="!!buttonLabel === true && buttonLabel.length > 0"
        :style="{ 'line-height': (buttonIconSize + 'px') }"
      ) {{ buttonLabel }}
    template(v-else)
      span(
        v-if="!!buttonLabel === true && buttonLabel.length > 0"
      ) {{ buttonLabel }}

    i.mdi(
      v-if="iconPosition === 'right' && loading === false && !!buttonIcon === true && buttonIcon.length > 0"
      :class="{ [buttonIcon]: true, 'ml-1': !!buttonLabel === true && buttonLabel.length > 0 }"
      :style="{ 'font-size': (buttonIconSize + 'px'), 'line-height': (buttonIconSize + 'px'), 'vertical-align': 'middle' }"
      aria-hidden="true")

    .sosButton__dropdown(v-if="actions.length > 0 && !loading && !disabled" ref="sosButtonDropdown" :class="{ 'sosButton__dropdown--up': direction === 'top' }")

      .sosButton__dropdownInner

        .sosButton__dropdownTitle(v-if="actionsTitle.length > 0")
          | {{ actionsTitle }}

        template(v-for="action in actions")

          .sosButton__dropdownSubtitle(v-if="action.id === 'TITLE'")

            | {{ action.title }}

          button(v-else @click="(e) => actionClick(e, action)")

            i.mdi.mr-2(
              :class="{ [action.icon]: true }"
              :style="{ 'font-size': (buttonIconSize + 'px'), 'line-height': (buttonIconSize + 'px'), 'vertical-align': 'middle' }"
              aria-hidden="true")

            span {{ action.title }}

</template>

<script>

  // https://stackoverflow.com/questions/48042274/conditional-event-binding-vuejs

  export default {
    name: 'SosButton',
    props: {
      direction: {
        type: String,
        default: () => 'bottom',
      },
      type: {
        type: String,
        default: () => 'button',
      },
      size: {
        type: String,
        default: () => 'small',
      },
      pulse: {
        type: Boolean,
        default: () => false,
      },
      uppercase: {
        type: Boolean,
        default: () => true,
      },
      loading: {
        type: Boolean,
        default: () => false,
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
      full: {
        type: Boolean,
        default: () => false,
      },
      rounded: {
        type: Boolean,
        default: () => false,
      },
      buttonIconSize: {
        type: String,
        default: () => '16',
        // required: true,
      },
      color: {
        type: String,
        default: () => 'default',
      },
      buttonLabel: {
        type: String,
        default: () => '',
      },
      buttonIcon: {
        type: String,
        default: () => '',
        // required: true,
      },
      iconPosition: {
        type: String,
        default: () => 'left',
      },

      //
      //
      //

      actionsTitle: {
        type: String,
        default: () => '',
      },

      actions: {
        type: Array,
        default: () => [],
      },
    },

    data () {
      return {
        showActions: false,

        isTabFocus: false, // Indicates if focus was by keyboard
        mouseClicked: false, // Tracks mouse interactions
      }
    },

    mounted () {
      if (this.actions.length > 0) document.addEventListener('mousedown', this.closeActions)
    },

    beforeDestroy () {
      if (this.actions.length > 0) document.removeEventListener('mousedown', this.closeActions)
    },

    methods: {
      //
      //
      //

      onFocus() {
        // If focus event is triggered and the mouse was not clicked
        if (!this.mouseClicked) {
          this.isTabFocus = true
        }
      },
      onKeydown(event) {
        // Reset mouseClicked and check for TAB key
        this.mouseClicked = false
        if (event.key === "Tab") {
          this.isTabFocus = true
        }
      },
      onBlur() {
        // When the button loses focus
        this.isTabFocus = false
      },
      onMouseDown() {
        // Mark mouse interaction
        this.mouseClicked = true
        this.isTabFocus = false
      },

      closeActions (event) {
        if (this.showActions === false) return false

        if (this.actions.length > 0 && !this.loading && !this.disabled) {
          // console.log('closeActions[actions]:', event)

          if (this.actions.length === 0) return false

          if (!this.$refs.sosButton.contains(event.target) && !this.$refs.sosButtonDropdown.contains(event.target)) this.showActions = false
        }
      },

      buttonClick (event) {
        if (this.type === 'submit') {
          // [24/01/25] console.log('buttonClick[submit]:', 'ESSE BOTÃO É DO TIPO "SUBMIT" E NÃO CHAMARÁ UM EVENTO PERSONALIZADO')
          return false
        }

        event.preventDefault()

        if (this.disabled === true) {
          // [24/01/25] console.log('buttonClick[disabled]:', !!this.buttonLabel === true && this.buttonLabel.length > 0 ? this.buttonLabel : this.buttonIcon)
          return false
        }

        if (this.actions.length > 0) {
          // [24/01/25] console.log('buttonClick[actions]: YES')

          this.showActions = !this.showActions

          return false
        }

        // [24/01/25] console.log('buttonClick[done]:', !!this.buttonLabel === true && this.buttonLabel.length > 0 ? this.buttonLabel : this.buttonIcon)

        this.$emit('buttonClick')
      },

      //
      //
      //

      actionClick (event, actionID)
      {
        // [24/01/25] console.log('actionClick[actionID]:', actionID)

        if (this.type === 'submit') {
          // [24/01/25] console.log('actionClick[submit]:', 'ESSE BOTÃO É DO TIPO "SUBMIT" E NÃO CHAMARÁ UM EVENTO PERSONALIZADO')
          return false
        }

        event.preventDefault()

        if (this.disabled === true) {
          // [24/01/25] console.log('actionClick[disabled]:', actionID)
          return false
        }

        // [24/01/25] console.log('actionClick[done]:', actionID)

        this.$emit('actionClick', actionID)
      },
    },
  }

</script>
